import React from 'react';
import Grid from '@material-ui/core/Grid';
import InfoLabel from 'UI/components/molecules/InfoLabel';

import { useStyles } from '../styles';

/**
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.value
 * @param {boolean} props.isFullWidth
 */
const LabelValue = ({ label, value, isFullWidth = false, ...rest }) => {
  const classes = useStyles();

  return (
    <Grid sm={isFullWidth ? 12 : 6} xs={12} className={classes.infoLabel} item>
      <InfoLabel title={label} description={value} canCopy {...rest} />
    </Grid>
  );
};

export default LabelValue;
